import React from "react";
import TenantSubTrendChart from './dependencies/tenantSubTrend';

const TenantSubTrend = () => {
  return (
    <div className="col-md-6 d-flex">
      <div className="card flex-fill">
        <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
          <h6 className="mb-0 d-flex align-items-center">
            <span className="db-chart-icon">
              <i className="ti ti-trending-up" />
            </span>
            Tenant Subscription Trend
          </h6>
        </div>
        <div className="card-body">
          <TenantSubTrendChart />
        </div>
      </div>
    </div>
  );
};

export default TenantSubTrend;
